import FormField from "components/FormField";
import MDModal from "components/MDModal";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useState } from "react";
import SoftMultiSelect from 'components/SoftMultiSelect'
import Grid from "@mui/material/Grid";
import { useAgencyInfo } from "context/agency";


function ModalComponent({ open, onClose, handleRefresh, supperAdminData}) {

  return (<>

    {open &&
      <div className="modal-zz-confirm text-left"  >
        <div className="scrollable-modal-content bg-white rounded" style={{ position: "relative", width: '70rem' }}>
          <span className='crossison' onClick={onClose}>X</span>
          {supperAdminData?.assistant_instructions && (
            <div
              dangerouslySetInnerHTML={{ __html: supperAdminData.assistant_instructions }}
            />
          )}
        </div>
      </div>}
  </>
  );
}
ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
  products: PropTypes.array,
  apps: PropTypes.array,
};
function Modal({ products, apps, handleRefresh, supperAdminData }) {
  const [openAddMember, setOpenAddMember] = useState(false);

  return (
    <>
      <p className="cursor-pointer" onClick={() => setOpenAddMember(true)} style={{ paddingTop: "10px", textDecoration: "underline", fontSize: "18px" }}>Instructions: How to Create An Agent</p>

      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        products={products}
        apps={apps}
        handleRefresh={handleRefresh}
        supperAdminData={supperAdminData}

      />

    </>
  );
}
Modal.propTypes = {
  products: PropTypes.array,
  handleRefresh: PropTypes.func,
  apps: PropTypes.array,
};
export default Modal;
